import React from "react";

import { Props } from "./types";

function WeatherIcon({ className, style }: Props) {
  return (
    <svg className={className} style={style} viewBox="0 0 20 20">
      <rect x="2" y="6" width="16" height="8" rx="4" />
      <rect x="6" y="3" width="9" height="8" rx="4" />
    </svg>
  );
}

export { WeatherIcon };
